<template>
  <section class="all_emp card_style">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between w-100 my-3">
      <div class="main_header_style">
        <h4>{{ $t("facilities") }}</h4>
      </div>

      <router-link to="/room-facilities/add" class="PrimaryButton btn">
        <i class="fa-solid fa-plus"></i> {{ $t("New facility") }}
      </router-link>

      <add-bed @fetch-data="fetchBedData" />
    </div>

    <!-- Facilities Table -->
    <div class="row">
      <table class="table" id="BedTable">
        <thead>
          <tr>
            <th>ID</th>
            <th>{{ $t("title") }}</th>
            <th>{{ $t("icon") }}</th>
            <th>{{ $t("Control") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(facility, index) in beds" :key="facility.id">
            <td>{{ facility.id }}</td>
            <td>{{ facility.title }}</td>
            <td>{{ facility.icon }}</td>
            <td>
              <router-link
                :to="`/room-facilities/edit/${facility.id}`"
                class="btn btn-success text-white mx-1"
              >
                <i class="fa-regular fa-pen-to-square"></i>
              </router-link>

              <button
                class="btn btn-danger text-white mx-1"
                @click="confirmDelete(facility.id, index)"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="row">
      <pagination
        :data="beds"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchBedData"
      >
        <template #prev-nav>&lt;</template>
        <template #next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import pagination from "laravel-vue-pagination";
import AddBed from "../../../../components/room/addBed.vue";

export default {
  name: "AllBeds",
  components: {
    pagination,
    AddBed,
  },

  data() {
    return {
      beds: [],
    };
  },

  methods: {
    async fetchBedData() {
      try {
        const { data } = await axios.post(`/fetch_room_facilities`, {
          with_pagination: 0,
        });
        this.beds = data.data || [];
      } catch (error) {
        this.handleError(error, this.$t("failed_to_load_data"));
      }
    },

    confirmDelete(id, index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) this.deleteBed(id, index);
      });
    },

    async deleteBed(id, index) {
      try {
        const { data } = await axios.post(`/delete_room_facilities`, {
          room_facilities_id: id,
        });

        if (data.status) {
          Swal.fire("", data.message, "success");
          this.beds.splice(index, 1);
        } else {
          Swal.fire("", data.message, "error");
        }
      } catch (error) {
        this.handleError(error, this.$t("delete_failed"));
      }
    },

    handleError(error, fallbackMessage) {
      const message =
        error.response?.data?.message || error.message || fallbackMessage;
      Swal.fire("", message, "error");
    },
  },

  created() {
    this.fetchBedData();
    this.clearLocalStorage();
  },

  methods: {
    ...{
      async fetchBedData() {
        try {
          const { data } = await axios.post(`/fetch_room_facilities`, {
            with_pagination: 0,
          });
          this.beds = data.data || [];
        } catch (error) {
          this.handleError(error, this.$t("failed_to_load_data"));
        }
      },

      confirmDelete(id, index) {
        Swal.fire({
          title: this.$t("check_delete"),
          text: this.$t("are_you_sure_delete"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: this.$t("back"),
          confirmButtonText: this.$t("confirm_delete"),
        }).then((result) => {
          if (result.isConfirmed) this.deleteBed(id, index);
        });
      },

      async deleteBed(id, index) {
        try {
          const { data } = await axios.post(`/delete_room_facilities`, {
            room_facilities_id: id,
          });

          if (data.status) {
            Swal.fire("", data.message, "success");
            this.beds.splice(index, 1);
          } else {
            Swal.fire("", data.message, "error");
          }
        } catch (error) {
          this.handleError(error, this.$t("delete_failed"));
        }
      },

      handleError(error, fallbackMessage) {
        const message =
          error.response?.data?.message || error.message || fallbackMessage;
        Swal.fire("", message, "error");
      },

      clearLocalStorage() {
        const keysToRemove = [
          "flightData",
          "flightTrips",
          "bookDataFlight",
          "bookDetails",
          "hotelData",
          "bookData",
        ];
        keysToRemove.forEach((key) => localStorage.removeItem(key));
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../_room";
</style>
